function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { createElement } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import Text from '../text';
import { ALL_TEXT_TAGS, UNWANTED_TAGS, BOLD_TAGS } from './constants';
import styles from './styles.module.scss';
import parse from 'html-react-parser';
var reactFaqStructuredDataAttributes = ['itemScope', 'itemType', 'itemProp'];
var faqStructuredDataAttributes = reactFaqStructuredDataAttributes.map(function (attr) {
  return attr.toLowerCase();
});
var htmlReactParserOptions = {
  transform: function transform(node, domNode) {
    var _ref = node,
        props = _ref.props,
        type = _ref.type,
        key = _ref.key;

    var _ref2 = 'attribs' in domNode ? domNode : {},
        _ref2$attribs = _ref2.attribs,
        attribs = _ref2$attribs === void 0 ? {} : _ref2$attribs; // replace lowercase attributes with camelCase, to make them react-friendly


    if (Object.keys(attribs).length) {
      faqStructuredDataAttributes.forEach(function (attribute, index) {
        var value = attribs[attribute];
        delete attribs[attribute]; // ensure both itemscope (with no value) or itemscope='' are added to the DOM

        attribs[reactFaqStructuredDataAttributes[index]] = value === '' ? 'true' : value;
      });
    }

    if (type && typeof type === 'string') {
      var propsWithKey = _objectSpread(_objectSpread({}, props), {}, {
        key: key !== null && key !== void 0 ? key : type + Math.random()
      });

      var children = props.children;
      if (UNWANTED_TAGS.includes(type)) return /*#__PURE__*/React.createElement("span", _extends({
        className: styles.block
      }, propsWithKey));else if (ALL_TEXT_TAGS.includes(type)) {
        var textProps = _objectSpread({}, propsWithKey);

        if (BOLD_TAGS.includes(type)) textProps.weight = 'semi-bold';
        return /*#__PURE__*/React.createElement(Text, _extends({
          as: type
        }, textProps), children);
      } else {
        return /*#__PURE__*/createElement(type, propsWithKey, children);
      }
    }

    return node;
  }
};

var HTMLToReact = function HTMLToReact(_ref3) {
  var html = _ref3.html;
  var DOMPurifyOptions = {
    ADD_TAGS: ['meta', 'link', 'style'],
    ADD_ATTR: ['content'].concat(_toConsumableArray(faqStructuredDataAttributes))
  };
  var purifiedHTML = DOMPurify.sanitize(html, DOMPurifyOptions);
  var HTML = parse(purifiedHTML, htmlReactParserOptions);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.htmlToReactContainer
  }, HTML);
};

export default HTMLToReact;